import { Resume } from '@rio/types'
import { SettingsFieldChangeHandler } from 'builder/modules/resumeEditor'
import { TooltipV2 } from 'builder/components/Tooltip'
import { useI18n } from 'builder/hooks/useI18n'
import { useLayoutAlignmentCustomisation } from '../../hooks/useLayoutAlignmentCustomisation'
import { Icons } from './assets'
import {
  SelectGroup,
  SelectControl,
  PlaceholderSpan,
  Label,
  FlexBox,
  ClickableOverlay,
} from './styles'

const STYLES = {
  SelectGroup,
  SelectControl,
  PlaceholderSpan,
  Label,
  FlexBox,
}

type Props = {
  resume: Resume
  onFieldChange?: SettingsFieldChangeHandler
  styles?: typeof STYLES
}

const TRANSLATION = 'builder.resume_editor.document_customization.sidebar.layout_tab'

export const LocationAlignmentSelection = (props: Props) => {
  const { i18n } = useI18n()
  const { value, onSelect, isDisabled } = useLayoutAlignmentCustomisation(
    'locationAlignment',
    props.resume,
    props.onFieldChange,
  )
  const Styles = props.styles || STYLES

  return (
    <TooltipV2
      value={i18n.t(`${TRANSLATION}.location_alignment_warning`)}
      width={250}
      multiline={true}
      position="bottom"
      isActive={isDisabled}
    >
      <Styles.SelectGroup>
        <Styles.SelectControl
          position="left"
          label={
            <Styles.Label htmlFor="location-alignment-left">
              {i18n.t(`${TRANSLATION}.left_alignment`)}
            </Styles.Label>
          }
        >
          <input
            type="radio"
            id="location-alignment-left"
            name="locationAlignment"
            value="left"
            checked={value === 'left' && !isDisabled}
            onChange={onSelect}
            disabled={isDisabled}
          />
          <Styles.FlexBox
            as="label"
            htmlFor="location-alignment-left"
            alignItems="flex-start"
            justifyContent="space-between"
            gap={4}
          >
            <ClickableOverlay />
            <Icons.LeftAlignment />
            <Styles.PlaceholderSpan>
              {' • '}
              {i18n.t(`${TRANSLATION}.location_alignment_label`)}
            </Styles.PlaceholderSpan>
          </Styles.FlexBox>
        </Styles.SelectControl>

        <Styles.SelectControl
          position="right"
          label={
            <Styles.Label htmlFor="location-alignment-right">
              {i18n.t(`${TRANSLATION}.right_alignment`)}
            </Styles.Label>
          }
        >
          <input
            type="radio"
            id="location-alignment-right"
            name="locationAlignment"
            value="right"
            checked={value === 'right' && !isDisabled}
            onChange={onSelect}
            disabled={isDisabled}
          />
          <Styles.FlexBox
            as="label"
            htmlFor="location-alignment-right"
            alignItems="flex-start"
            justifyContent="space-between"
            gap={20}
          >
            <ClickableOverlay />
            <Icons.LeftAlignment />
            <Styles.PlaceholderSpan alignText="right">
              {i18n.t(`${TRANSLATION}.location_alignment_label`)}
            </Styles.PlaceholderSpan>
          </Styles.FlexBox>
        </Styles.SelectControl>
      </Styles.SelectGroup>
    </TooltipV2>
  )
}
